import { useContext } from "react";
import CurrentUserContext from "../contexts/CurrentUserContext";

const useCurrentUserContext = () => {
    return useContext(CurrentUserContext);
}
export default useCurrentUserContext;